import './styles/globals.css'

import React from 'react'
import 'react-material-symbols/outlined'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import { PublicClientApplication } from '@azure/msal-browser'

import { MetaTags } from './components/MetaTags'
import { createRoutes } from './createRoutes'

type Props = {
  publicClient: PublicClientApplication
}

const App: React.FC<Props> = ({ publicClient }) => {
  const router = createBrowserRouter([createRoutes(publicClient)])

  return (
    <>
      <MetaTags />
      <RouterProvider router={router} />
    </>
  )
}

export default App
